import React from "react";
import "../../assets/css/steps-container.css";
import { PhraseKey, Say } from "../../languages";

type StepContainerProps = {
  enabled: boolean;
  visible: boolean;
  titlePhraseKey?: PhraseKey;
  children: React.ReactNode;
  hideTitle: boolean;
  className?: string;
};

const StepContainer = (props: StepContainerProps) => {
  const { enabled, visible, titlePhraseKey, hideTitle = false, className = "", children } = props;
  const enabledClass = enabled ? "enabled-true" : "enabled-false";
  const noTitleClass = (!titlePhraseKey || !!hideTitle) === true ? "step-container__no-title" : "";

  if (!visible) {
    return null;
  }

  return (
    <div className={`step-container ${enabledClass} ${noTitleClass} ${className}`}>
      {titlePhraseKey && !hideTitle ? (
        <h2 className={`step-header __staple`}>
          <Say phrase={titlePhraseKey} />
        </h2>
      ) : null}

      {children}
    </div>
  );
};

export default StepContainer;
